var _path, _path2, _g, _path3, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNewLookup = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 161,
  height: 160,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F2F8FC",
  d: "M80.51 156.997c42.519 0 76.987-34.468 76.987-76.987S123.029 3.023 80.51 3.023 3.523 37.492 3.523 80.011s34.469 76.986 76.988 76.986"
})), /*#__PURE__*/React.createElement("mask", {
  id: "new_lookup_svg__a",
  width: 86,
  height: 86,
  x: 41,
  y: 35,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M41.389 35.555h85.333v85.333H41.389z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#new_lookup_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#00E2BC",
  d: "M51.167 103.111q-1.134 0-1.9-.771-.767-.771-.767-1.911t.767-1.896 1.9-.755h30.222q1.133 0 1.9.77.767.772.767 1.912t-.767 1.895-1.9.756zm0-18.667q-1.134 0-1.9-.77-.767-.772-.767-1.912t.767-1.895 1.9-.756H63.61q1.134 0 1.9.771.767.771.767 1.911t-.767 1.896-1.9.755zm0-18.666q-1.134 0-1.9-.772-.767-.77-.767-1.91t.767-1.896q.766-.756 1.9-.756H63.61q1.134 0 1.9.771.767.771.767 1.911t-.767 1.896-1.9.756zm40 26.666q-7.378 0-12.578-5.2t-5.2-12.577q0-7.38 5.2-12.578 5.2-5.2 12.578-5.2t12.577 5.2 5.2 12.578a17.3 17.3 0 0 1-.888 5.51 16.9 16.9 0 0 1-2.667 4.978l12.355 12.356q.8.8.8 1.867t-.8 1.866-1.866.8-1.867-.8l-12.355-12.355a16.9 16.9 0 0 1-4.978 2.666 17.3 17.3 0 0 1-5.511.89m-.021-5.333q5.176 0 8.82-3.624t3.645-8.8q0-5.175-3.623-8.82t-8.8-3.645q-5.177 0-8.821 3.624t-3.645 8.8q0 5.175 3.624 8.82t8.8 3.645"
}))), /*#__PURE__*/React.createElement("mask", {
  id: "new_lookup_svg__b",
  width: 58,
  height: 86,
  x: 69,
  y: 35,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M69.834 35.555h56.889v85.333l-28.445-14.222-28.444-22.222z"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#new_lookup_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#0A78CD",
  d: "M51.167 103.111q-1.134 0-1.9-.771-.767-.771-.767-1.911t.767-1.896 1.9-.755h30.222q1.133 0 1.9.77.767.772.767 1.912t-.767 1.895-1.9.756zm0-18.667q-1.134 0-1.9-.77-.767-.772-.767-1.912t.767-1.895 1.9-.756H63.61q1.134 0 1.9.771.767.771.767 1.911t-.767 1.896-1.9.755zm0-18.666q-1.134 0-1.9-.772-.767-.77-.767-1.91t.767-1.896q.766-.756 1.9-.756H63.61q1.134 0 1.9.771.767.771.767 1.911t-.767 1.896-1.9.756zm40 26.666q-7.378 0-12.578-5.2t-5.2-12.577q0-7.38 5.2-12.578 5.2-5.2 12.578-5.2t12.577 5.2 5.2 12.578a17.3 17.3 0 0 1-.888 5.51 16.9 16.9 0 0 1-2.667 4.978l12.355 12.356q.8.8.8 1.867t-.8 1.866-1.866.8-1.867-.8l-12.355-12.355a16.9 16.9 0 0 1-4.978 2.666 17.3 17.3 0 0 1-5.511.89m-.021-5.333q5.176 0 8.82-3.624t3.645-8.8q0-5.175-3.623-8.82t-8.8-3.645q-5.177 0-8.821 3.624t-3.645 8.8q0 5.175 3.624 8.82t8.8 3.645"
}))));
export default SvgNewLookup;